import React from "react";
import SbEditable from "storyblok-react";
import InsightsLogo from "src/images/insights-logo.svg";

const TitleAndDate = ({ blok }) => {
  const textColour =
    blok.content_type === "magazine" ? blok.primary_colour : "#2e2d2c";

  const textChange =
    blok.content_type === "magazine"
      ? "max-w-xl mx-auto text-center font-insights-display text-4xl md:text-5xl font-semibold"
      : "font-display text-4xl md:text-5xl";

  const month = new Date(blok.first_published_at).getMonth();
  const season =
    month <= 5
      ? "Spring"
        ? month <= 8
        : "Summer"
        ? month <= 11
        : "Fall"
      : "Winter";

  const date =
    blok.content_type === "magazine"
      ? season + " " + new Date(blok.first_published_at).getFullYear()
      : new Date(blok.first_published_at).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="bg-white">
        <div className="mx-auto mt-12 max-w-7xl px-6 lg:mt-16">
          {blok.content_type === "magazine" ? (
            <div className="mb-6 w-auto">
              <InsightsLogo className="mx-auto h-[45px] w-[45px]" />
            </div>
          ) : (
            ""
          )}
          <h1 className={`${textChange}`}>
            <span className="block" style={{ color: textColour }}>
              {blok.title}
            </span>
          </h1>
          <div
            className={`text-grey ${
              blok.content_type === "magazine"
                ? "text-xxs font-insights-display mx-auto mt-5 max-w-xl text-center font-medium uppercase"
                : "font-body text-[0.7rem] italic"
            }`}
          >
            <p>
              {blok.date
                ? blok.date
                : date === "Invalid Date"
                ? "Date not shown in editor"
                : date}
            </p>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default TitleAndDate;
